<template>
	<div style="width: 75rem;margin: 0 auto;margin-top: 1.875rem;">
		<p style="font-size: 1.5rem;">动物订购申请</p>
		<p style="font-size: 1rem;">一、实验及人员信息</p>
		<a-form-model ref="ruleForm" :model="form" :rules="rules">

			<a-row>
				<a-col :span="10">
					<a-form-model-item ref="name" label="项目名称" prop="systemNo">
						<a-select @change="changeOrders"  placeholder="请填写项目名称" v-model="form.systemNo" @blur="
			             () => {
			               $refs.name.onFieldBlur();
			             }
			           " >
					   <a-select-option  v-for="item in userList.ealist" :key="item.id">
					         {{item.slnum}}
					    </a-select-option>
					   </a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="2">
					<a-form-model-item ref="name" label="项目负责人" >
						<a-input disabled placeholder="请填写项目负责人" v-model="form.projectUnit" @blur="
			             () => {
			               $refs.name.onFieldBlur();
			             }
			           " />
					</a-form-model-item>



				</a-col>
				<a-col :span="10">
					<a-form-model-item ref="name" label="伦理审查编号" prop="experimentalUnit">
						<a-input  placeholder="请填写伦理审查编号" v-model="form.experimentalUnit" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       " />
					   <!-- <a-select @change="changeOrderss"  placeholder="请选择项目" v-model="form.experimentalUnit" @blur="
			             () => {
			               $refs.name.onFieldBlur();
			             }
			           " >
					   <a-select-option  v-for="item in userList.ealist" :key="item.acceptanceNo">
					         {{item.name}}
					    </a-select-option>
					   </a-select>-->
					</a-form-model-item> 
				</a-col>
				<a-col :span="10" :offset="2">
					<a-form-model-item ref="name" label="项目编号" >
						<a-input disabled placeholder="请填写项目编号" v-model="userIDss" @blur="
			             () => {
			               $refs.name.onFieldBlur();
			             }
			           " />
					</a-form-model-item>



				</a-col>
			</a-row>
			<a-row>
				<a-col :span="10">
					<p style="font-size: 0.875rem;color: #000000A6;margin-top: 1.25rem;font-weight: 600;">动物实验负责人</p>
					<a-form-model-item ref="name" label="姓名" prop="responsible.name">
						   <!-- <a-select show-search option-filter-prop="children" @select="selectName" placeholder="请输入姓名" v-model="form.responsible.name" @blur="
						        () => {
						          $refs.name.onFieldBlur();
						        }
						      " >
						      <a-select-option v-for="item in userMsgList" :key="item.userId">
						            {{item.realName }}
						          </a-select-option>
						      </a-select> -->
							  <a-select
							  @select="selectName"
							  label-of-value
							      show-search
							     option-filter-prop="children"
							       v-model="form.responsible.name"
							      placeholder="请输入搜索条件支持拼音/中文"
							      :filter-option="false"
							      :not-found-content="fetching ? undefined : null"
							      @search="fetchUser"
							      @change="handleChange4"
							    >
							      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
							      <a-select-option v-for="d in data" :value="d.userId" >
							        {{ d.realName }}--{{d.unit}}
							      </a-select-option>
							    </a-select>
					</a-form-model-item>
					<a-form-model-item ref="name" label="电话">
						<a-input disabled placeholder="请输入电话号码" v-model="form.responsible.phone" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="邮箱" >
						<a-input disabled placeholder="请输入邮箱" v-model="form.responsible.email" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="职称/学位" >
						<a-input disabled placeholder="请输入职称/学位" v-model="form.responsible.degree" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="2">
					<p style="font-size: 0.875rem;color: #000000A6;margin-top: 1.25rem;font-weight: 600;">订购人</p>
					<a-form-model-item ref="name" label="姓名" >
						<a-input  disabled placeholder="请输入姓名" v-model="form.order.name" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="电话">
						<a-input disabled placeholder="请输入电话号码" v-model="form.order.phone" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="邮箱" >
						<a-input disabled placeholder="请输入邮箱" v-model="form.order.email" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="职称/学位" >
						<a-input disabled placeholder="请输入职称/学位" v-model="form.order.degree" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
				</a-col>
			</a-row>
			<p style="font-size: 1rem;margin-top: 1.5625rem;">二、动物品种及笼位需求</p>
			<div v-for="(item,i) in form.demandData" :key="i">

				<a-row>
					<a-col :span="24">
						<div
							style="font-size: 0.875rem;color: #000000A6;margin-top: 1.25rem;border-bottom: 1px solid rgba(0, 0, 0, 0.15);padding-bottom: 0.4375rem;margin-bottom: 1.875rem;">
							笼位申请{{i+1}}</div>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="饲养区域">
							<a-radio-group @change="changeType(i)" v-model="form.demandData[i].entryType">
								<!-- <a-radio value="屏障区">
									屏障区
								</a-radio>
								<a-radio value="A2">
									A2区
								</a-radio>
								<a-radio value="普通级大动物区">
									普通级大动物区
								</a-radio> -->
								<a-radio :value="item.animalTypeId" v-for="(item,index) in userList.tyep">
									{{item.animalName}}
								</a-radio>
							</a-radio-group>
						</a-form-model-item>

					</a-col>

				</a-row>
				<a-row>
					<a-row>
						<a-col :span="10">
							<a-form-model-item ref="name" label="动物品种">
								<a-select placeholder="请填写动物品种" v-model="form.demandData[i].animalType" @blur="
						         () => {
						           $refs.name.onFieldBlur();
						         }
						       " >
							   <a-select-option v-for="item in userList.animal" :key="item.animalXxxId">
							         {{item.animalName }}
							       </a-select-option>
							</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span="10" :offset="2">
							<a-form-model-item ref="name" label="平均饲养周期（天）">
								<a-input-number :disabled="!form.demandData[i].entryType"  style="width: 100%;" @change="changeDay(i)"  placeholder="请填写平均饲养周期" v-model="form.demandData[i].feedCycle" @blur="
						         () => {
						           $refs.name.onFieldBlur();
						         }
						       " />
							</a-form-model-item>
						</a-col>
						<a-col :span="10">
							<a-form-model-item ref="name" label="申请笼位数量">
								<a-input-number :disabled="!form.demandData[i].entryType" style="width: 100%;" @change="changeNumber(i)"  placeholder="请填写申请笼位数量" v-model="form.demandData[i].cagesNum" @blur="
						         () => {
						           $refs.name.onFieldBlur();
						         }
						       " />
							</a-form-model-item>
						</a-col>
						<a-col :span="10" :offset="2">
							<a-form-model-item ref="name" label="费用计算">
								<div style="display: flex;justify-content: space-between;">
									<div style="display: flex;align-items: flex-start;">
										<p>饲养费用：</p>
										<a-input disabled placeholder="元" style="width: 8.25rem;" v-model="form.demandData[i].feedExpenses"
											@blur="
										  () => {
										    $refs.name.onFieldBlur();
										  }
										" />
									</div>
									<div style="display: flex;align-items: flex-start;">
										<p>需预缴费用：</p>
										<a-input disabled placeholder="元" style="width: 8.25rem;" v-model="form.demandData[i].prepaidExpenses"
											@blur="
										  () => {
										    $refs.name.onFieldBlur();
										  }
										" />
									</div>
								</div>



							</a-form-model-item>
						</a-col>
					</a-row>
				</a-row>
				<div style="display: flex;justify-content: space-between;align-items: flex-end;">
				
						<div>
							
						</div>
				
					<a-popconfirm okText="确认" cancelText="取消"  title="确认是否删除?"
						@confirm="() => onDeleteDe(i)">
						<p style="margin-right: 6.25rem;font-size: 0.875rem;color: #F64C4C;cursor: pointer;">删除</p>
					</a-popconfirm>
				</div>
			</div>
			<div style="width: 100%;height: 0.0625rem;background-color: rgba(0, 0, 0, 0.15);">
				
			</div>
					<a-button style="width: 6.125rem;height: 2.25rem;margin: 1rem 0;margin-bottom: 5rem;" type="primary" icon="plus"
										@click="demandAdd">
										添加
									</a-button>
			<a-row>
				<a-col :span="10">
					<a-form-model-item ref="name" label="合计费用计算">
						<div style="display: flex;justify-content: space-between;">
							<div style="display: flex;align-items: flex-start;">
								<p>饲养费用：</p>
								<a-input disabled placeholder="元" style="width: 8.25rem;" v-model="form.feedExpenses" @blur="
								  () => {
								    $refs.name.onFieldBlur();
								  }
								" />
							</div>
							<div style="display: flex;align-items: flex-start;">
								<p>需预缴费用：</p>
								<a-input disabled placeholder="元" style="width: 8.25rem;" v-model="form.prepaidExpenses" @blur="
								  () => {
								    $refs.name.onFieldBlur();
								  }
								" />
							</div>
						</div>



					</a-form-model-item>
				</a-col>
			</a-row>
			<p style="font-size: 1rem;margin-top: 1.5625rem;">三、订购动物信息</p>
			<a-row>
				<a-col :span="24">
					<!-- <p style="font-size: 0.875rem;color: #000000A6;margin-top: 1.25rem;">参与动物实验操作人员信息</p> -->

					<a-table :scroll="{  y: 390  }" :pagination="{ pageSize: 10000 }" class="animall" bordered :data-source="form.animalOrderMsg" :columns="columns2">
						<template slot="Species" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Species', $event)" />
						</template>
						<template slot="Grade" slot-scope="text, record">
<!-- 							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Grade', $event)" /> -->
						<a-select style="width: 100px" :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Grade', $event)">
							<a-select-option   key="普通级">
							    普通级
							</a-select-option>
							<a-select-option   key="SPF级">
							   SPF
							</a-select-option>
						</a-select>
						</template>
						<template slot="Age" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Age', $event)" />
						</template>
						<template slot="Age2" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Age2', $event)" />
						</template>
						<template slot="Quantityc" slot-scope="text, record">
							<!-- <a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Quantityc', $event)" /> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Quantityc', $event)">
								<a-select-option   key="雄性">
								    雄性
								</a-select-option>
								<a-select-option   key="雌性">
								   雌性
								</a-select-option>
								<a-select-option   key="雌雄不限">
								   雌雄不限
								</a-select-option>
							</a-select>
						</template>
						<template slot="Quantityx" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Quantityx', $event)" />
						</template>
						<!-- <template slot="Supplier" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Supplier', $event)" />
						</template> -->
						<!-- <template slot="Permit" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'Permit', $event)" />
						</template>
						<template slot="aniPrice" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'aniPrice', $event)" />
						</template>
						<template slot="aniAllPrice" slot-scope="text, record">
							{{record.aniPrice*record.Quantityx}}
						</template>
						
						<template slot="aniUnit" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'aniUnit', $event)" />
						</template>
						<template slot="usePeople" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'usePeople', $event)" />
						</template>
						<template slot="addUnit" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text" @change="onCellChange(record.key, 'addUnit', $event)" />
						</template> -->
						<template slot="operation" slot-scope="text, record">
							<a-popconfirm okText="确认" cancelText="取消" v-if="form.animalOrderMsg.length" title="确认是否删除?"
								@confirm="() => onDelete2(record.key)">
								<a style="color: red;" href="javascript:;">删除</a>
							</a-popconfirm>
						</template>

					</a-table>
					<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary" icon="plus"
						@click="handleAdd2">
						添加
					</a-button>
				</a-col>
			</a-row>
			<div style="margin: 16px 0pt;">
				
			</div>
			<a-row>
				<a-col :span="24">
					<a-form-model-item ref="name" label="供货单位">
					
					   <a-select @change="changeGoodset" style="width: 100%" v-model="form.newPage2.supplierName">
					   	<a-select-option  :value="items.supplierId"   v-for="items in goodsetData">
					   	    {{items.supplierName}}
					   	</a-select-option>
					   </a-select>
					</a-form-model-item>
				</a-col>
				<a-col span="10" :offset="index%2==0?0:4" v-for="(item,index) in modelsData">
					<a-form-model-item ref="name" :label="item.topicName" >
						<a-input :placeholder="'请填写'+item.topicName" v-model="forms[item.topicValue]" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<!-- <a-col :span="10" >
					<a-form-model-item ref="name" label="接货人手机">
						<a-input placeholder="请填写接货人手机" v-model="form.newPage2.receivePhone" @blur="
			             () => {
			               $refs.name.onFieldBlur();
			             }
			           "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="收货地址">
						<a-input placeholder="请填写收货地址" v-model="form.newPage2.CourierAddress" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" >
					<a-form-model-item ref="name" label="动物实验单位">
						<a-input placeholder="请填写动物实验单位" v-model="form.newPage2.animalExperimentUnit" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					   
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="纳税人识别号">
						<a-input placeholder="请填写纳税人识别号" v-model="form.newPage2.TaxpayerIdentificationNumber" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" >
					<a-form-model-item ref="name" label="单位地址">
						<a-input placeholder="请填写单位地址" v-model="form.newPage2.UnitAddress" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="单位电话">
						<a-input placeholder="请填写单位电话" v-model="form.newPage2.unitPhone" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<a-form-model-item ref="name" label="开户行及账号">
						<a-input placeholder="请填写开户行及账号" v-model="form.newPage2.OpeningBankAndAccountNumber " @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="发票类型">
						
					   <a-select style="width: 100%" v-model="form.newPage2.InvoiceType">
					   	<a-select-option   key="普通发票">
					   	    普通发票
					   	</a-select-option>
					   	<a-select-option   key="专用发票">
					   	   专用发票
					   	</a-select-option>
					   	<a-select-option   key="增值税专用发票">
					   	   增值税专用发票
					   	</a-select-option>
					   </a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<a-form-model-item ref="name" label="电子发票接收邮箱">
						<a-input placeholder="请填写单位电话" v-model="form.newPage2.ElectronicInvoiceEmail" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="2号运输笼具">
						<a-input-number style="width: 100%;" placeholder="请填写2号运输笼具费用" v-model="form.newPage2.transportCage" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<a-form-model-item ref="name" label="运输费">
						<a-input-number style="width: 100%;" placeholder="请填写运输费" v-model="form.newPage2.transportCost" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="订货单位名称">
						<a-input placeholder="请填写订货单位名称" v-model="form.newPage2.orderanimalExperimentUnit" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<a-form-model-item ref="name" label="发票抬头">
						<a-input placeholder="请填写发票抬头" v-model="form.newPage2.InvoiceTitle" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="备注">
						<a-input placeholder="请填写备注" v-model="form.newPage2.StandbyContact" @blur="
				         () => {
				           $refs.name.onFieldBlur();
				         }
				       "/>
					</a-form-model-item>
				</a-col> -->
			</a-row>
			<!-- <p style="font-size: 1rem;margin-top: 1.5625rem;">四、附件</p>
			<a-row>
				<a-col :span="10">
					<div style="display: flex;align-items: baseline;">
						<p>1、动物实验计划书</p>
					
					</div>
					
					<div style="width: 100px;margin-bottom: 50px;">
						<a-upload
						
						method="post"
						  list-type="text"
						  name="input"
						  :action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
						   :file-list="fileList1"
						   @change="handleChange1"
						>
						  <a-button> <a-icon type="upload" /> 点击上传 </a-button>
						</a-upload>
					</div>
					


				</a-col>
				<a-col :span="10" :offset="4">
					<div style="display: flex;align-items: baseline;">
						<p>2、动物实验申请表</p>
						
					</div>
					<div style="width: 100px;">
						<a-upload
						
						method="post"
						  list-type="text"
						  name="input"
						  :action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
						   :file-list="fileList2"
						   @change="handleChange2"
						>
						  <a-button> <a-icon type="upload" /> 点击上传 </a-button>
						</a-upload>
					</div>


				</a-col>
				<a-col :span="24">
					<div style="display: flex;align-items: baseline;">
						<p>3、其他附件</p>
						
					</div>
					<div style="width: 100px;">
						<a-upload
						
						method="post"
						  list-type="text"
						  name="input"
						 :action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
						   :file-list="fileList3"
						   @change="handleChange3"
						>
						  <a-button> <a-icon type="upload" /> 点击上传 </a-button>
						</a-upload>
					</div>


				</a-col> -->
			</a-row>
			<div v-if="this.$route.query.status=='详情'" style="margin: 30px 0;">
				
			</div>
			<div style="display: flex;justify-content: center;margin: 8.125rem 0;" v-if="this.$route.query.status!=='详情'">
				<a-button v-if="this.$route.query.id&&this.$route.query.state=='审核'" @click="onSubmitJg" type="primary" style="width: 22.5rem;height: 3.75rem;">
					审核
				</a-button>
				<a-popconfirm v-if="this.$route.query.id&&this.$route.query.status=='PI审核'" @click="onSubmitJg" title="该动物实验是否审核通过?" ok-text="通过" cancel-text="否决" @confirm="AnimalExperimentPiReview(true)"
					@cancel="AnimalExperimentPiReview(false)">
				<a-button  type="primary" style="width: 22.5rem;height: 3.75rem;">
					审核
				</a-button>
				</a-popconfirm>
				<a-button v-else @click="onSubmit" type="primary" style="width: 22.5rem;height: 3.75rem;">
					提交
				</a-button>
			</div>
			<div  style="display: flex;justify-content: center;margin: 8.125rem 0;" v-else-if="this.$route.query.status=='详情'" >
				<a-button @click="$router.go(-1)" type="primary" style="width: 22.5rem;height: 3.75rem;">
					返回
				</a-button>
			</div>
			<tutorReviewList ref="tutorReviewList"></tutorReviewList>
		</a-form-model>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import debounce from 'lodash/debounce';
	import axios from 'axios'
	import Qs from 'qs'
	import EditableCell from '../../components/editableCell.vue'
	import tutorReviewList from '../../components/tutorReviewList.vue'
	import {VerificationApply,ApplyExperimentModel,SelUserList,UpdateAe,SelPersonalData,Isadministrators,SelAnimalExperiment,GetSupplier} from '@/api/index.js'
	import { scrollAnimation } from '../../utils/js/scrollAnimation.js';
	export default {
		name:'/animalApply',
		components: {
			EditableCell,
			tutorReviewList
		},
		inject:['reload'],
		watch:{
		$route(){
			this.reload()
		}
		},
		created(){
			GetSupplier().then(((res)=>{
				this.goodsetData = res.data.data
				
				this.modelsData = JSON.parse(res.data.data[0].topic) 
				this.form.newPage2.supplierName = res.data.data[0].supplierId
				console.log(this.modelsData)
			}))
			SelUserList().then((res)=>{
				this.$store.commit('updateUserList',res.data.data)
			})
			
			axios.get('/Flat/GetSupplier').then((res)=>{
				this.goodsHome = res.data.data
			})
			this.runModel = process.env.NODE_ENV
			this.lastFetchId = 0
			this.fetchUser = debounce(this.fetchUser, 800)
			// let noticeData  = this.$route.params.data
			// this.noticeData = noticeData
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 0)
			// this.userList = JSON.parse(window.localStorage.getItem('userList'))?JSON.parse(window.localStorage.getItem('userList')):[]
			this.getVerificationApply()
			this.getSelUserList()
			SelPersonalData().then((res)=>{
				this.form.order.name = res.data.data.realName
				this.form.order.email = res.data.data.email
				this.form.order.phone = res.data.data.tol 
				this.form.order.degree = res.data.data.identityTitle
			})
			
			console.log(this.form.demandData)
			if(this.$route.query.id&&(this.$route.query.state=='编辑'||this.$route.query.state=='审核')){
				this.form.animalOrderMsg = []
				console.log(this.userList)
				SelAnimalExperiment({AnimalExperimentId:this.$route.query.id,page:1,limit:1}).then((res)=>{
					SelUserList().then((resd)=>{
						let data = {}
						data = res.data.data[0]
						this.animalDatas = data
						let userLists = resd.data.data
							console.log(data)
							//
							
							let selectedMsg = {}
							userLists.map((n)=>{
								if(n.userId==data.agentId){
									selectedMsg=n
								}
							})
							this.data = [selectedMsg]
							this.form.responsible.phone =  selectedMsg.tol
							this.form.responsible.email =  selectedMsg.email
							this.form.responsible.degree = selectedMsg.applicantSchool 
							///
							this.form.responsible.name = data.applicantId
							///
							this.form.demandData = JSON.parse(data.demandData)
							
							if(JSON.parse(JSON.parse(data.demandData)[0].fileList1)[0]){
							
							this.fileList1.push(JSON.parse(data.demandData)[0].fileList1?JSON.parse( JSON.parse(data.demandData)[0].fileList1)[0]:{})
							
							
							}
							if(JSON.parse( JSON.parse(data.demandData)[0].fileList2)[0]){
							
							this.fileList2.push(JSON.parse(data.demandData)[0].fileList2?JSON.parse( JSON.parse(data.demandData)[0].fileList2)[0]:[]) 
							
							}
							if(JSON.parse( JSON.parse(data.demandData)[0].fileList3)[0]){
							
										
							this.fileList3.push(JSON.parse(data.demandData)[0].fileList3?JSON.parse( JSON.parse(data.demandData)[0].fileList3)[0]:[])
							}
							
							
							this.form.systemNo = data.ethicalReviewForTeachId,
							

							GetSupplier().then(((resg)=>{
				resg.data.data.map((nn,ii)=>{
					if(nn.supplierId==data.supplierId){
						this.modelsData = JSON.parse(resg.data.data[ii].topic)
					}
				})
			}))

							this.forms = JSON.parse(data.orderUnitName)
							this.caches = JSON.parse(data.orderUnitName)

							this.form.projectUnit = data.feedingPlan,
							this.form.experimentalUnit = data.acceptanceNo,
							this.numSource.map((n)=>{
								if(n.slnum.split('(')[0]==data.slnum){
									this.userIDss = n.slnum?n.slnum.split('(')[0]:''
								}
							})
							this.form.responsible.name = data.agentId,
							this.form.animalOrderMsg = JSON.parse(data.animal)
							this.form.demandData = JSON.parse(data.demandData)
							
							
							this.form.newPage2.transportCage = data.transportCageCost
							this.form.newPage2.transportCost = data.transportCost
							this.form.newPage2.supplierName = data.supplierId

							this.cachesId = data.supplierId

							this.form.newPage2.orderanimalExperimentUnit = data.orderanimalExperimentUnit
							this.form.newPage2.CourierAddress = data.courierAddress
							this.form.newPage2.InvoiceTitle = data.invoiceTitle
							this.form.newPage2.StandbyContact = data.standbyContact
							this.form.newPage2.remarks = data.remarks
							this.form.newPage2.receivePhone = data.receivePhone
							this.form.newPage2.receiveName = data.receiveName
							this.form.newPage2.animalExperimentUnit = data.animalExperimentUnit
							this.form.newPage2.TaxpayerIdentificationNumber = data.taxpayerIdentificationNumber
							this.form.newPage2.UnitAddress = data.unitAddress
							this.form.newPage2.unitPhone = data.unitPhone
							this.form.newPage2.OpeningBankAndAccountNumber = data.openingBankAndAccountNumber
							this.form.newPage2.InvoiceType = data.invoiceType
							this.form.newPage2.ElectronicInvoiceEmail = data.electronicInvoiceEmail
							
							
							this.form.demandData.map((n,i)=>{
								this.form.demandData[i].isDeleted=true
							})
							
							let sumExpense = 0
							let sumPresumExpense = 0
							this.form.demandData.map((n)=>{
								sumExpense+=n.feedExpenses
								sumPresumExpense+=n.prepaidExpenses
							})
							this.form.feedExpenses=sumExpense
							this.form.prepaidExpenses=sumPresumExpense
							this.valueCage = JSON.parse(data.demandData)[0].valueCage
							this.dayCage = JSON.parse(data.demandData)[0].dayCage
							this.numCage = JSON.parse(data.demandData)[0].numCage
							
							let Count1 = this.form.animalOrderMsg.map((n)=>{
								return n.key
							})
							
							let maxCount1 = Math.max(...Count1)
							this.count = maxCount1
							// Agreement:'',
							// AnimalUnit:'',
							// Certification:'',
							// laboratoryAnimalList:laboratoryAnimalList
						})
					})
					
				
			}
			// if(this.$route.query.id&&this.$route.query.state=='审核'){
				
			// 	let data = this.$route.params.data
			// 	console.log(data)
			// 	//
			// 	let selectedMsg = {}
			// 	this.$store.state.userList.map((n)=>{
			// 		if(n.userId==data.agentId){
			// 			selectedMsg=n
			// 		}
			// 	})
			// 	this.data = [selectedMsg]
			// 	this.form.responsible.phone =  selectedMsg.tol
			// 	this.form.responsible.email =  selectedMsg.email
			// 	this.form.responsible.degree = selectedMsg.applicantSchool 
			// 	///
			// 	this.form.responsible.name = data.applicantId
			// 	///
			// 	this.form.systemNo = data.ethicalReviewForTeachId,
				
			// 	this.form.projectUnit = data.feedingPlan,
			// 	this.form.experimentalUnit = data.experimentName,
			// 	this.form.responsible.name = data.agentId,
			// 	this.form.animalOrderMsg = JSON.parse(data.animal)
			// 	this.form.demandData = JSON.parse(data.demandData)
			// 	if(JSON.parse( JSON.parse(data.demandData)[0].fileList1)[0]){
			// 	this.fileList1.push(JSON.parse(data.demandData)[0].fileList1?JSON.parse( JSON.parse(data.demandData)[0].fileList1)[0]:{})
			// 	}
			// 	if(JSON.parse( JSON.parse(data.demandData)[0].fileList2)[0]){
			// 	this.fileList2.push(JSON.parse(data.demandData)[0].fileList2?JSON.parse( JSON.parse(data.demandData)[0].fileList2)[0]:[]) 
				
			// 	}
			// 	if(JSON.parse( JSON.parse(data.demandData)[0].fileList3)[0]){
			// 	this.fileList3.push(JSON.parse(data.demandData)[0].fileList3?JSON.parse( JSON.parse(data.demandData)[0].fileList3)[0]:[])
			// 	}
				
			// 	let sumExpense = 0
			// 	let sumPresumExpense = 0
			// 	this.form.demandData.map((n)=>{
			// 		sumExpense+=n.feedExpenses
			// 		sumPresumExpense+=n.prepaidExpenses
			// 	})
			// 	this.form.feedExpenses=sumExpense
			// 	this.form.prepaidExpenses=sumPresumExpense
			// 	this.valueCage = JSON.parse(data.demandData)[0].valueCage
			// 	this.dayCage = JSON.parse(data.demandData)[0].dayCage
			// 	this.numCage = JSON.parse(data.demandData)[0].numCage
				
			// 	// Agreement:'',
			// 	// AnimalUnit:'',
			// 	// Certification:'',
			// 	// laboratoryAnimalList:laboratoryAnimalList
			// }
		},
		computed:{
			...mapState(['userData','userList'])
		},
		methods: {
			changeGoodset(val){
				console.log(val)
				this.forms = {}
				if(this.cachesId==val){
					this.forms = this.caches
					
				}
				GetSupplier().then(((res)=>{
				res.data.data.map((n,i)=>{
					if(n.supplierId==val){
						this.modelsData = JSON.parse(res.data.data[i].topic)
					}
				})
				// this.modelsData = JSON.parse(res.data.data[0].topic) 
				// console.log(this.modelsData)
			
			}))
			console.log(this.caches)
			// debugger
			},
			async AnimalExperimentPiReview(state){
				
				const res = await axios.post('/Flat/AnimalExperimentPiReview',Qs.stringify({id:Number(this.$route.query.id),State:state}))
				if(res.data.state){
					this.$message.success(res.data.info)
					this.$router.push({path:'/core/aniApplication'})
				}
				else{
					this.$message.error(res.data.info)
				}
				
			},
			changeOrders(data){
				console.log(this.numSource)
				this.numSource.map((n)=>{
					console.log(n)
					if(n.id==data){
						this.form.experimentalUnit = n.acceptanceNo 
						this.form.projectUnit = n.tuname
						this.userIDss = n.slnum?n.slnum.split('(')[0]:''
					}
				})
				console.log(this.form.systemNo)
			},
			// changeOrderss(data){
				
			// 	console.log(this.numSource)
			// 	this.numSource.map((n)=>{
			// 		console.log(n)
			// 		if(n.acceptanceNo==data){
						
			// 			this.userIDss = n.acceptanceNo
			// 		}
			// 	})
			// 	console.log(this.form.systemNo)
			// },
			async getVerificationApply(){
				
				let data = {}
				if(this.$route.query.status=='详情'){
					data = {Isdetails:true}
				}
				
				const res = await VerificationApply(data)
				if(res.data.state){
					this.userList = res.data.data
					console.log(this.userList)
					
					let isInvalid = true
					this.numSource = res.data.data.ealist
				}
				var that = this
				if(this.$route.query.state=='编辑'||this.$route.query.state=='审核'){
					const userListdd = this.userList
				const res1 = await SelAnimalExperiment({AnimalExperimentId:that.$route.query.id,page:1,limit:1})
				// res1.data.data[0].slnum
				
				
				userListdd.ealist.map((n)=>{
					if(n.slnum.split('(')[0]==res1.data.data[0].slnum){
						isInvalid = false
					}
				})
				
				if(isInvalid){
					this.$info({
					        title: '该编号实验有效期已过无法编辑和审核，请申请新增或重新申请',
					        okText:'OK',
					        onOk() {
								that.$router.push({path:'/core/aniApplication'})
							},
					});
					return
				}
					return
				}
				if(res.data.state==false){
					this.$info({
					        title: res.data.info,
					        okText:'返回',
					        onOk() {
								that.$router.go(-1)
							},
					      });
				}
				else if(res.data.state==true){
					console.log(res.data)
				}
				
			},
			onSubmitJg(){
				this.$refs.tutorReviewList.visible= true
				this.$refs.tutorReviewList.Title='导师审核'
				this.$refs.tutorReviewList.data = this.animalDatas
			},
			onSubmit() {
				console.log(this.forms)
			
				const currentY = document.documentElement.scrollTop || document.body.scrollTop
				let isSock = false
				if(this.form.systemNo==''||(this.form.experimentalUnit==''||!this.form.experimentalUnit)||this.form.responsible.name==''){
					scrollAnimation(currentY, 0)
				}
				else{
					this.form.demandData.map((n,i)=>{
						console.log(n)
						 // entryType animalType feedCycle cagesNum
						
						// for(var item of n){
						// 	if(item==''){
						// 		scrollAnimation(currentY, 0)
						// 	}
						// }
						if(n.entryType==''||n.animalType==''||n.feedCycle==''||n.cagesNum==''||!n.entryType||!n.animalType||!n.feedCycle||!n.cagesNum){
							this.$message.error("笼位申请"+Number(i+1)+'填写错误,提交失败')
							scrollAnimation(currentY, 1000)
							isSock = true
						}
					})
				}
				
				
				if(isSock){
					return
				}
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						
						let laboratoryAnimalList = []
							this.form.demandData.map((n)=>{
								laboratoryAnimalList.push({
									AnimalTypeId:n.entryType,
									AnimalXxxId:n.animalType,
									FeedingDays:n.feedExpenses,
									CageCount:n.cagesNum
								})
							})
							console.log(laboratoryAnimalList)
							this.form.demandData[0].valueCage=this.valueCage
							this.form.demandData[0].dayCage=this.dayCage
							this.form.demandData[0].numCage=this.numCage
							this.form.demandData[0].fileList1 = this.fileList1.length>0?JSON.stringify(this.fileList1):"[]"
							this.form.demandData[0].fileList2 =  this.fileList2.length>0?JSON.stringify(this.fileList2):"[]"
							this.form.demandData[0].fileList3 =  this.fileList3.length>0?JSON.stringify(this.fileList3):"[]"
						let	FORM = {
							EthicalReviewForTeachId:this.form.systemNo,
							FeedingPlan:this.form.projectUnit,
							AcceptanceNo:this.form.experimentalUnit,
							AgentId:this.form.responsible.name,
							Animal: JSON.stringify(this.form.animalOrderMsg),
							Agreement:this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:'',
							AnimalUnit:this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:'',
							Certification:this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:'',
							laboratoryAnimalList:laboratoryAnimalList,
							demandData:JSON.stringify(this.form.demandData),
							transportCageCost:this.form.newPage2.transportCage,
							transportCost:this.form.newPage2.transportCost,
							supplierId:this.form.newPage2.supplierName,
							orderanimalExperimentUnit:this.form.newPage2.orderanimalExperimentUnit,
							CourierAddress:this.form.newPage2.CourierAddress,
							InvoiceTitle:this.form.newPage2.InvoiceTitle,
							StandbyContact:this.form.newPage2.StandbyContact,
							receivePhone:this.form.newPage2.receivePhone,
							receiveName:this.form.newPage2.receiveName,
							animalExperimentUnit:this.form.newPage2.animalExperimentUnit,
							TaxpayerIdentificationNumber:this.form.newPage2.TaxpayerIdentificationNumber,
							UnitAddress:this.form.newPage2.UnitAddress,
							unitPhone:this.form.newPage2.unitPhone,
							openingBankAndAccountNumber:this.form.newPage2.OpeningBankAndAccountNumber,
							InvoiceType:this.form.newPage2.InvoiceType,
							electronicInvoiceEmail:this.form.newPage2.ElectronicInvoiceEmail,
							orderUnitName:JSON.stringify(this.forms),
							
						}
						
						if(this.$route.query.id&&this.$route.query.state=='编辑'){
								console.log("测试")
								
							this.animalDatas.laboratoryAnimalOrderlist.map((n,i)=>{
								if(FORM.laboratoryAnimalList[i]){
									FORM.laboratoryAnimalList[i].laboratoryAnimalOrderId = n.laboratoryAnimalOrderId
								}
								
							})
							this.deleteList.map((n)=>{
								FORM.laboratoryAnimalList.push(n)
							})
							FORM.EthicalReviewForTeachId = this.form.systemNo
							FORM.AnimalExperimentId = this.animalDatas.animalExperimentId
							const res = UpdateAe(FORM).then((res)=>{
								if(res.data.state==true){
									this.$message.success("修改申请成功")
									this.$router.push({path:'/core/aniApplication'})
								}
								else{
									this.$message.error(res.data.info)
								}
							})
						}else{
							const res = ApplyExperimentModel(FORM).then((res)=>{
								if(res.data.state==true){
									this.$message.success("申请成功")
									this.$router.push({path:'/core/aniApplication'})
								}
								else{
									this.$message.error(res.data.info)
								}
							})
						}
							
							console.log(FORM)
							
					} else {
						console.log(this.form)
						this.$message.error("请填写必填信息")
						console.log('error submit!!');
						console.log(this.form.demandData)
						
						return false;
					}
				});
			},
			handleAdd2() {
				
				console.log(this.count)
				let {
					count,
					form
				} = this;
				count+=1
				const newData = {
					key: count,
					Species: "",
					                    Grade: "普通级",
					                    Age: "",
					                    Quantityc: "",
					                    Quantityx: "",
					                    Supplier: "",
					                    Permit: "",
										aniPrice:"",
										aniAllPrice:"",
										aniUnit:"",
										usePeople:"",
										addUnit:""
				};
				this.form.animalOrderMsg = [...form.animalOrderMsg, newData];
				this.count = count + 1;
			},
			onDelete2(key) {
				const dataSource = [...this.form.animalOrderMsg];
				if(this.form.animalOrderMsg.length==1){
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.animalOrderMsg = dataSource.filter(item => item.key !== key);
			},
			onCellChange(key, dataIndex, value) {
				const dataSource = [...this.form.animalOrderMsg];
				const target = dataSource.find(item => item.key === key);
				if (target) {
					target[dataIndex] = value.target?value.target.value:value;
					this.form.animalOrderMsg = dataSource;
				}
				console.log(this.form.animalOrderMsg)
			},
			demandAdd(){
				this.form.demandData.push({
						entryType: "", //进驻类型
						animalType: "", //动物品种
						cagesNum: "", //申请笼位数量
						feedExpenses: "", //饲养费用
						prepaidExpenses: "", //需预缴费用
						feedCycle: "", //平均饲养周期（天）
					})
			},
			onDeleteDe(index){
				console.log(this.form.demandData)
				
				//  return
				if(this.form.demandData.length==1){
					this.$notification.open({
						       message: '提示信息',
						       description:
						         '删除失败，请至少填写一行信息',
						       icon: <a-icon type="meh" style="color: #108ee9" />,
						     });
				
					return
				}
				// this.form.demandData.map((n,i)=>{
				// 	if(index==i&&n.isDeleted){
				// 		this.deleteList.push(n)
				// 	}
				// })
				this.animalDatas.laboratoryAnimalOrderlist.map((n,i)=>{
					if(index==i){
						
						this.deleteList.push({
									AnimalTypeId:n.animalTypeId,
									AnimalXxxId:n.animalXxxId,
									FeedingDays:n.feedingDays,
									CageCount:n.cageCount,
									LaboratoryAnimalOrderId:n.laboratoryAnimalOrderId,
									isDeleted:true
								})
					}
				})
				this.form.demandData.splice(index,1)
				
				this.valueCage.splice(index,1)
				this.dayCage.splice(index,1)
				this.numCage.splice(index,1)
				let sumExpense = 0
				let sumPresumExpense = 0
				this.form.demandData.map((n)=>{
					sumExpense+=n.feedExpenses
					sumPresumExpense+=n.prepaidExpenses
				})
				console.log(sumExpense)
				this.form.feedExpenses=sumExpense
				this.form.prepaidExpenses=sumPresumExpense
			},
			changeDay(val){
				// if(this.numCage[val]==undefined){
				// 	this.numCage[val]=1
				// }
				// console.log(this.form.demandData[val])
				this.dayCage[val] = this.form.demandData[val].feedCycle
				console.log(this.numCage[val])
				this.form.demandData[val].feedExpenses=this.valueCage[val]*this.dayCage[val]*this.numCage[val]
				this.form.demandData[val].prepaidExpenses = this.form.demandData[val].feedExpenses/2
				let sumExpense = 0
				let sumPresumExpense = 0
				this.form.demandData.map((n)=>{
					sumExpense+=n.feedExpenses
					sumPresumExpense+=n.prepaidExpenses
				})
				console.log(sumExpense)
				this.form.feedExpenses=sumExpense
				this.form.prepaidExpenses=sumPresumExpense
			},
			async getSelUserList(){
				const res = await SelUserList()
				this.userMsgList = res.data.data
				console.log(res)
			},
			changeNumber(val){
				// if(this.dayCage[val]==undefined){
				// 	this.dayCage[val]=1
				// }
				this.numCage[val] = this.form.demandData[val].cagesNum
				console.log(this.form.demandData[val])
				
				this.form.demandData[val].feedExpenses=this.valueCage[val]*this.dayCage[val]*this.numCage[val]
				this.form.demandData[val].prepaidExpenses = this.form.demandData[val].feedExpenses/2
				console.log(this.form.demandData)
				let sumExpense = 0
				let sumPresumExpense = 0
				this.form.demandData.map((n)=>{
					sumExpense+=n.feedExpenses
					sumPresumExpense+=n.prepaidExpenses
				})
				console.log(sumExpense)
				this.form.feedExpenses=sumExpense
				this.form.prepaidExpenses=sumPresumExpense
				
			},
				selectName(data,item){
				let userData = this.$store.state.userData
				let selectedMsg = {}
				 userData.map((n)=>{
					if(n.userId==data){
						selectedMsg = n
					}
				})
				this.data = [selectedMsg]
				this.form.responsible.phone =  selectedMsg.tol
				this.form.responsible.email =  selectedMsg.email
				this.form.responsible.degree = selectedMsg.applicantSchool 
				
			},
			changeType(val){
				let selectedKey = this.form.demandData[val].entryType
				let price = 0
				console.log(this.userList.price)
				this.userList.price.map((n,i)=>{
					if(n.animalTypeId==selectedKey){
						price = n.djPrice
						return
					}
				})
				if(this.dayCage[val]==undefined){
					this.dayCage[val]=1
				}
				if(this.numCage[val]==undefined){
					this.numCage[val]=1
				}
				
				this.valueCage[val]= price
				this.form.demandData[val].feedExpenses=this.valueCage[val]*this.dayCage[val]*this.numCage[val]
				this.form.demandData[val].prepaidExpenses = this.form.demandData[val].feedExpenses/2
				let sumExpense = 0
				let sumPresumExpense = 0
				this.form.demandData.map((n)=>{
					sumExpense+=n.feedExpenses
					sumPresumExpense+=n.prepaidExpenses
				})
				console.log(sumExpense)
				this.form.feedExpenses=sumExpense
				this.form.prepaidExpenses=sumPresumExpense
				
			},
			handleChange1(val){
				console.log(val)
				this.fileList1 = [val.file]
			},
			handleChange2(val){
				console.log(val)
				this.fileList2 = [val.file]
			},
			handleChange3(val){
				console.log(val)
				this.fileList3 = [val.file]
			},
			fetchUser(value) {
				if(value==''){
					return
				}
				
				 if (value.indexOf(" ") != -1) {
				        this.$message.error("搜索条件不能包含空字符")
				        return
				}
			      console.log('fetching user', value);
			      this.lastFetchId += 1;
			      const fetchId = this.lastFetchId;
			      this.data = [];
			      this.fetching = true;
			      axios.post('/Flat/SelUserList',Qs.stringify({name:value}))
			        .then((res)=>{
						this.fetching = false
						this.data = res.data.data
						this.$store.commit('updateUserData',res.data.data)
						console.log(this.data)
					}
					)
			       
			    },
			    handleChange4(value) {
			      Object.assign(this, {
			        value,
			        data: [],
			        fetching: false,
			      });
			    },
		},
		
		
		data() {
			return {
				caches:[],
				cachesId:"",
				modelsData:[],
				goodsetData:[],
				forms:{
					
				},
				userIDss:'',
				goodsHome:[],
				numSource:[],
				animalDatas:[],
				runModel:'',
				data: [],
				value: [],
				fetching: false,
				fileList1:[],
				fileList2:[],
				fileList3:[],
				deleteList:[],
				userList:[],
				userMsgList:[],
				userMsg:JSON.parse(window.localStorage.getItem('User'))?JSON.parse(window.localStorage.getItem('User')):'',
				valueCage:[],
				dayCage:[],
				numCage:[],
				rules: {
					demandData: 
						{
							animalType: [{
								required: true,
								message: '动物品种不能为空，请填写',
								trigger: 'blur'
							}],
						},
					entryType: [{
						required: true,
						message: '项目类型不能为空，请勾选',
						trigger: 'change'
					}, ],
					systemNo: [{
						required: true,
						message: '项目名称不能为空，请填写',
						trigger: 'blur'
					}],
					experimentalUnit: [{
						required: true,
						message: '伦理审查编号不能为空，请填写',
						trigger: 'blur'
					}],
					// experimentalUnit: [{
					// 	required: true,
					// 	message: '项目负责人不能为空，请填写',
					// 	trigger: 'blur'
					// }],
					feedCycle: [{
						required: true,
						message: '平均饲养周期（天）不能为空，请填写',
						trigger: 'blur'
					}],
					animalType: [{
						required: true,
						message: '动物品种不能为空，请填写',
						trigger: 'blur'
					}],
					cagesNum: [{
						required: true,
						message: '申请笼位数量不能为空，请填写',
						trigger: 'blur'
					}],
					responsible: {
						name: [{
							required: true,
							message: '姓名不能为空，请填写',
							trigger: 'blur'
						}],
						phone: [{
							required: true,
							message: '电话不能为空，请填写',
							trigger: 'blur'
						}],
						email: [{
							required: true,
							message: '邮箱不能为空，请填写',
							trigger: 'blur'
						}],
						degree: [{
							required: true,
							message: '职称/学位不能为空，请填写',
							trigger: 'blur'
						}],
					},
					order: {
						name: [{
							required: true,
							message: '姓名不能为空，请填写',
							trigger: 'blur'
						}],
						phone: [{
							required: true,
							message: '电话不能为空，请填写',
							trigger: 'blur'
						}],
						email: [{
							required: true,
							message: '邮箱不能为空，请填写',
							trigger: 'blur'
						}],
						degree: [{
							required: true,
							message: '职称/学位不能为空，请填写',
							trigger: 'blur'
						}],
					}
				},
				count: 1,
				columns2: [{
						title: '动物品种/品系',
						dataIndex: 'Species',
						scopedSlots: {
							customRender: 'Species'
						},
						
					},
					// {
					// 	title: '级别',
					// 	dataIndex: 'Grade',
					// 	scopedSlots: {
					// 		customRender: 'Grade'
					// 	},
					// },
					{
						title: '年龄',
						dataIndex: 'Age',
						scopedSlots: {
							customRender: 'Age'
						},
					},
					{
						title: '体重',
						dataIndex: 'Age2',
						scopedSlots: {
							customRender: 'Age2'
						},
					},
					{
						title: '性别',
						dataIndex: 'Quantityc',
						scopedSlots: {
							customRender: 'Quantityc'
						},
					},
					// {
					// 	title: '单价',
					// 	dataIndex: 'aniPrice',
					// 	scopedSlots: {
					// 		customRender: 'aniPrice'
					// 	},
					// },
					{
						title: '数量',
						dataIndex: 'Quantityx',
						scopedSlots: {
							customRender: 'Quantityx'
						},
					},
					// {
					// 	title: '总价',
					// 	dataIndex: 'aniAllPrice',
					// 	scopedSlots: {
					// 		customRender: 'aniAllPrice'
					// 	},
					// },
					// {
					// 	title: '单位',
					// 	dataIndex: 'aniUnit',
					// 	scopedSlots: {
					// 		customRender: 'aniUnit'
					// 	},
					// },
					// {
					// 	title: '供应单位',
					// 	dataIndex: 'Supplier',
					// 	scopedSlots: {
					// 		customRender: 'Supplier'
					// 	},
					// },
					// {
					// 	title: '许可证编号',
					// 	dataIndex: 'Permit',
					// 	scopedSlots: {
					// 		customRender: 'Permit'
					// 	},
					// },
					
					// {
					// 	title: '使用人',
					// 	dataIndex: 'usePeople',
					// 	scopedSlots: {
					// 		customRender: 'usePeople'
					// 	},
					// },
					// {
					// 	title: '合格证购买单位',
					// 	dataIndex: 'addUnit',
					// 	scopedSlots: {
					// 		customRender: 'addUnit'
					// 	},
					// },
					
					
					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						width:80,
						fixed:'right',
					},
				],
				form: {
					newPage2:{
						transportCage:'',
						transportCost:'',
						supplierName:'',
						orderanimalExperimentUnit:'',
						CourierAddress:'',
						InvoiceTitle:'',
						StandbyContact:'',
						remarks:'',
						receivePhone:'',
						receiveName:'',
						animalExperimentUnit:'',
						TaxpayerIdentificationNumber:'',
						UnitAddress:'',
						unitPhone:'',
						OpeningBankAndAccountNumber:'',
						InvoiceType:'',
						ElectronicInvoiceEmail:'',
						
					},
					demandData: [{
							entryType: "", //进驻类型
							animalType: "", //动物品种
							cagesNum: "", //申请笼位数量
							feedExpenses: "", //饲养费用
							prepaidExpenses: "", //需预缴费用
							feedCycle: "", //平均饲养周期（天）
						}
						
					],

					systemNo: "", //项目名称
					projectUnit: "", //项目名称
					experimentalUnit: "", //项目负责人



					responsible: { //动物实验负责人
						name: "",
						phone: "",
						email: "",
						degree: "", //职称/学位
					},
					order: { //订购人
						name: "",
						phone: "",
						email: "",
						degree: "", //职称/学位
					},
					animalOrderMsg: [{
						key: 0,
						Species: "", //动物品系
						Grade: "普通级", //级别
						Age: "", //年龄体重
						Quantityc: "", //公数量
						Quantityx: "", //母数量
						Supplier: "", //供应单位
						Permit: "", //培训及能力描述
						aniPrice:'',
						aniAllPrice:'',
						aniUnit:'',
						usePeople:'',
						addUnit:''
						
					}],
				}
			}
		}
	}
</script>

<style>
	.animall .ant-input{
		border-color:  transparent !important;
		/* cursor: pointer; */
	}
</style>
